import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Input,
  Label,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Tooltip,
  Row,
  CardImg,
} from 'reactstrap';
import ImageGallery from '../../../propinfo/gallery/index';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DynamicFlow from './DynamicFlow';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { gAPI_QuestionSets } from '../../../../../../constants/APIs';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
let arr = [];
export default function Features({
  channelDetails,
  saveIntegration,
}) {
  const [showRooms, setShowRooms] = useState(channelDetails?.showRoomsButton || false);
  const [showRates, setShowRates] = useState(channelDetails?.showRatesButton || false);
  const [showTemplate, setShowTemplate] = useState(channelDetails?.enableTemplates || false);
  const [templates, setTemplates] = useState(
    channelDetails?.templates && Array.isArray(channelDetails.templates)
      ? channelDetails.templates.map((t) =>
        typeof t === 'string' ? { name: '', details: t } : { name: t.name || '', details: t.details || '' }
      )
      : [{ name: '', details: '' }]
  );

  const quillModules = {
    toolbar: [
      [{ header: '1' }, { header: '2' }, { font: [] }],
      [{ size: [] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      ['link', 'image'],
      ['clean'],
    ],
  };

  const quillFormats = [
    'header',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
  ];
  const handleShowRooms = (e) => {
    console.log('e', e, e?.target);
    setShowRooms(e);
  };

  const handleShowRates = (e) => {
    console.log('e', e, e?.target);
    setShowRates(e);
  };

  const handleSave = () => {
    let settings = channelDetails;
    settings.showRoomsButton = showRooms;
    settings.showRatesButton = showRates;
    settings.enableTemplates = showTemplate;
    settings.templates = templates;
    console.log('auto', settings);
    saveIntegration({ settings });
  };

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6>Features</h6>
          </div>
          <Separator className="mb-3" />
          <div className="row mt-2 ml-2 mb-3">
            <Colxx md="12" className="mb-2">
              <h6 className="mb-1">Select Rooms & Add to Email</h6>
              <div className="text-muted small">Add room options based on customer requirements without leaving this screen, and include selected rooms in the email for quick reference or follow-up.</div>
            </Colxx>
            <Colxx md="12" className="mb-3">
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small "
                checked={showRooms}
                name="showRooms"
                onChange={(e) => handleShowRooms(e)}
              />

            </Colxx>
            <Colxx md="12" className="mb-2">
              <h6 className="mb-1">Select Rates & Add to Email</h6>
              <div className="text-muted small">Add rates and availability based on customer requirements without leaving Outlook, and include a “Book Now” link in the email for quick reference or booking.</div>
            </Colxx>
            <Colxx md="12" className="mb-3">
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small "
                checked={showRates}
                name="showRates"
                onChange={(e) => handleShowRates(e)}
              />

            </Colxx>
            <Colxx md="12" className="mb-2">
              <h6 className="mb-1">Generate Template Response</h6>
              <div className="text-muted small mb-2">Choose from saved templates to respond quickly and consistently.</div>
            </Colxx>
            <Colxx md="12" className="mb-3">
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small "
                checked={showTemplate}
                name="showTemplate"
                onChange={(e) => setShowTemplate(e)}
              />
            </Colxx>
            <Colxx md="12" className="mb-2">
              <div className="ml-2">
                {showTemplate && (
                  <div>
                    {templates.map((t, idx) => (
                      <Row className="mb-3" key={idx}>
                        <Colxx md="10">
                          <Row>
                            <Colxx md="6" className="mb-2">
                              <Input
                                type="text"
                                value={t.name}
                                placeholder="Template Name"
                                onChange={(ev) => {
                                  const copy = [...templates];
                                  copy[idx] = { ...copy[idx], name: ev.target.value };
                                  setTemplates(copy);
                                }}
                              />
                            </Colxx>
                            <Colxx md="12" className="mb-2">
                              <ReactQuill
                                theme="snow"
                                value={t.details}
                                onChange={(content, delta, source, editor) => {
                                  if (source === 'user') {
                                    const copy = [...templates];
                                    copy[idx] = { ...copy[idx], details: content };
                                    setTemplates(copy);
                                  }
                                }}
                                modules={quillModules}
                                formats={quillFormats}
                                placeholder="Template Details"
                              />
                            </Colxx>
                          </Row>
                        </Colxx>
                        <Colxx md="2" className=" d-flex align-items-center">
                          <Button color="danger" outline size="xs" key="button" onClick={() => {
                            const copy = [...templates];
                            copy.splice(idx, 1);
                            setTemplates(copy.length ? copy : [{ name: '', details: '' }]);
                          }}>
                            x
                          </Button>
                        </Colxx>


                      </Row>

                    ))}
                    <Button
                      className="mt-3"
                      color="primary"
                      size="xs"
                      outline
                      onClick={() => setTemplates([...templates, { name: '', details: '' }])}
                    >
                      + Add Template
                    </Button>
                  </div>
                )}
              </div>
            </Colxx>
            {/* <Separator className="mb-3" /> */}
          </div>
          <Separator className="mb-3" />
          <Colxx md="12" className="text-center">
            <Button onClick={() => handleSave()} color="primary" size="xs">
              Save
            </Button>
          </Colxx>
        </CardBody>
      </Card>
    </Fragment>
  );
}
